import { createReducer } from 'pobble-components/dist/redux-helpers'

const VISIBLE_PUPILS = 20
const LOAD_MORE_STEP = 20

const cacheSelectedGroups = groups => {
  if (!Object.keys(groups).length) {
    localStorage.removeItem('dashboardSelectedGroups')
  } else {
    localStorage.setItem('dashboardSelectedGroups', JSON.stringify(groups))
  }
  return groups
}

const groupsStorage = localStorage.getItem('dashboardSelectedGroups')

let defaultState = {
  showSelected: false,
  selectedPupils: {},
  sortBy: {
    key: null,
    direction: null
  },
  searchValue: '',
  selectedGroupsCategory: 'ALL',
  filterDialogOpened: false,
  selectedGroups: groupsStorage ? JSON.parse(groupsStorage) : {},
  selectedGroupsTemp: {},
  visiblePupils: VISIBLE_PUPILS,
  groupAction: false
}

const PupilsComponentReducer = createReducer(defaultState, {
  'PUPILS_COMPONENT:SET_SELECT_STATUS': (state, { id, status }) => ({
    ...state,
    selectedPupils: {
      ...state.selectedPupils,
      [id]: status
    }
  }),
  'PUPILS_COMPONENT:SET_SELECT_STATUSES': (state, { statuses }) => ({
    ...state,
    selectedPupils: statuses
  }),
  'PUPILS_COMPONENT:SET_SORT_KEY': (state, { key, direction }) => ({
    ...state,
    sortBy: { key, direction }
  }),
  'PUPILS_COMPONENT:CHANGE_SEARCH_VALUE': (state, { value }) => ({
    ...state,
    searchValue: value,
    visiblePupils: VISIBLE_PUPILS
  }),
  'PUPILS_COMPONENT:SHOW_FILTER_DIALOG': state => ({
    ...state,
    filterDialogOpened: true
  }),
  'PUPILS_COMPONENT:HIDE_FILTER_DIALOG': state => ({
    ...state,
    filterDialogOpened: false
  }),
  'PUPILS_COMPONENT:APPLY_GROUPS_FILTER': (state, { selectedGroups }) => ({
    ...state,
    selectedGroups: cacheSelectedGroups(selectedGroups),
    visiblePupils: VISIBLE_PUPILS,
    filterDialogOpened: false
  }),
  'PUPILS_COMPONENT:RESET_FILTER': state => ({
    ...state,
    selectedGroups: cacheSelectedGroups({}),
    visiblePupils: VISIBLE_PUPILS
  }),
  'GROUPS_STORE:DELETE_REQUEST': state => {
    return {
      ...defaultState,
      selectedGroups: cacheSelectedGroups({}),
      groupAction: false
    }
  },
  'PUPILS_COMPONENT:LOAD_MORE': state => ({
    ...state,
    visiblePupils: state.visiblePupils + LOAD_MORE_STEP
  }),
  'PUPILS_STORE:RETIRE_PUPIL_REQUEST_SUCCESS': (state, { params }) => {
    const selectedPupils = { ...state.selectedPupils }
    delete selectedPupils[params.id]
    return {
      ...state,
      selectedPupils
    }
  },
  'PUPILS_COMPONENT:SHOW_SELECTED': state => ({ ...state, showSelected: true }),
  'PUPILS_COMPONENT:UNSET_SHOW_SELECTED': state => ({
    ...state,
    showSelected: false
  }),
  'PUPILS_COMPONENT:CHANGE_GROUP_CATEGORY': (state, { category }) => ({
    ...state,
    selectedGroupsCategory: category
  }),
  'GROUPS_COMPONENT:GROUP_ACTION': (state, { id }) => ({
    ...state,
    selectedGroups: cacheSelectedGroups({ [id]: true }),
    groupAction: true
  })
})

export default PupilsComponentReducer
